export default __webpack_public_path__ + "7fc2d369579a2cb2fd1663278a7616ff.png";